import { useAuth } from 'context/auth-context';
import dayjs, { Dayjs } from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { useQuery, UseQueryResult } from 'react-query';
import { GymRetrieve } from 'types';
import { client } from 'utils/api-client';
import { normalizeTimezone } from 'utils/date-functions';

dayjs.extend(utc);
dayjs.extend(timezone);

function useGym(gymId?: string | null): UseQueryResult<{ data: GymRetrieve }> {
  return useQuery(['gyms', gymId], () => client.get(`gyms/${gymId}/`), {
    enabled: !!gymId,
  });
}

export function useSessionGymLocalDateTime(): Dayjs | undefined {
  const { session } = useAuth();
  const { data: gymData } = useGym(session?.gym?.gymId);
  const gymTimezone = gymData?.data?.timezone;

  return !!gymTimezone ? dayjs().tz(normalizeTimezone(gymTimezone)) : undefined;
}

export default useGym;
